<template>
  <div id="app">
    <link rel="stylesheet" href="https://unpkg.com/vue-material@beta/dist/theme/default-dark.css">
    <link rel="stylesheet" href="//fonts.googleapis.com/css?family=Roboto:300,400,500,700,400italic">
    <link rel="stylesheet" href="//fonts.googleapis.com/icon?family=Material+Icons">
    <div>
      <router-view v-title="title"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return {
      title: 'Trivia'
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue